const icons = {
	leaf: '<path d="M11 20A7 7 0 0 1 4 13C4 7 11 3 20 3c0 9-4 16-11 16z"/><path d="M11 20v-7"/>',
	timer: '<circle cx="12" cy="13" r="8"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="13" x2="15" y2="13"/><line x1="12" y1="2" x2="12" y2="5"/><line x1="10" y1="2" x2="14" y2="2"/>',
	shield: '<path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><path d="M9 12l2 2 4-4"/>',
	pan: '<ellipse cx="10" cy="13" rx="7" ry="5"/><path d="M3 13c0 3 3.1 5.5 7 5.5s7-2.5 7-5.5"/><path d="M17 13l5-3"/>',
	paintbrush: '<path d="M18.37 2.63a2.12 2.12 0 0 1 3 3L13.5 13.5 8 15l1.5-5.5z"/><path d="M14 6.5l3.5 3.5"/><path d="M9 14.5L5 18.5a2.5 2.5 0 0 0 3.5 3.5L12.5 18"/>',
	flame: '<path d="M8.5 14.5A4.5 4.5 0 0 0 13 19a4.5 4.5 0 0 0 4.5-4.5c0-3-2.5-5-3.5-7.5-1 2.5-3 3-4 4.5a3 3 0 0 0-1.5 2.5z"/><path d="M12 2c1 3.5 6 7 6 12a6 6 0 1 1-12 0c0-4 3-7.5 6-12z"/>',
}

const apps = [
	{
		id: 'plantpal',
		name: 'PlantPal Snap',
		developer: 'Greenleaf Labs',
		category: 'Education',
		color: 'bg-green',
		icon: 'leaf',
		rating: 4.7,
		ratingCount: '18K',
		tagline: 'Your AI plant expert. Name any plant in a snap.',
		description:
			'Point your camera at any leaf or flower and our AI tells you its name in seconds. PlantPal was trained on over 10 million labeled plant photos, so it can recognize more than 20,000 species, even in lighting it has never seen before.',
		features: ['Identify plants from a photo', 'Care tips for houseplants', 'Save your finds to a garden journal'],
		screenshots: ['Snap a leaf', 'It’s a maple!', 'Your garden journal'],
		review: {
			author: 'Maya, 12',
			text: 'I used it on a hike and it knew every flower. Even one my grandma couldn’t name!',
		},
		answer: 'data',
		clues: ['trained on over 10 million labeled plant photos', 'never seen before'],
		how: 'Millions of plant photos, each labeled with the right name.',
		explanation:
			'PlantPal learned what plants look like from millions of labeled examples. It can name a photo it has never seen. No person could write a rule for every leaf in every kind of light.',
	},
	{
		id: 'focusflow',
		name: 'FocusFlow',
		developer: 'BrightMind Apps',
		category: 'Productivity',
		color: 'bg-orange',
		icon: 'timer',
		rating: 4.2,
		ratingCount: '5.4K',
		tagline: 'Study smarter with the power of AI!',
		description:
			'Our revolutionary AI-powered timer helps you study smarter! FocusFlow gives you 25 minutes of work, then a 5-minute break, then repeats. After four rounds you earn a 15-minute break.',
		features: ['Smart AI study sessions', 'Gentle chime at every break', 'Track how many rounds you finish'],
		screenshots: ['25:00 Focus', 'Break time!', '4 rounds done'],
		review: {
			author: 'Priya, 13',
			text: 'Helps me stop checking my phone during homework.',
		},
		answer: 'rules',
		clues: ['25 minutes of work, then a 5-minute break, then repeats.', 'After four rounds you earn a 15-minute break.'],
		how: 'Work 25 minutes, then break 5 minutes. After 4 rounds, break 15 minutes.',
		explanation:
			'Words like “revolutionary” and “smart” sound impressive, but the listing describes a fixed schedule. FocusFlow does the same thing for every student, every time. It never learns from anyone’s study habits.',
	},
	{
		id: 'chatguard',
		name: 'ChatGuard',
		developer: 'SafeSignal Inc.',
		category: 'Utilities',
		color: 'bg-blue-dark',
		icon: 'shield',
		rating: 4.6,
		ratingCount: '31K',
		tagline: 'AI that keeps scam texts out of your inbox.',
		description:
			'ChatGuard’s AI checks every incoming message and moves suspicious ones to a separate folder. Each time someone reports a scam, ChatGuard learns from it and gets better at spotting new tricks.',
		features: ['Automatic scam folder', 'Report a message in one tap', 'Works quietly in the background'],
		screenshots: ['Inbox: all clear', '3 messages moved', 'Report a scam'],
		review: {
			author: 'Sam’s dad',
			text: 'Caught a fake delivery text I almost clicked. Worth it.',
		},
		answer: 'data',
		clues: ['learns from it and gets better at spotting new tricks.'],
		how: 'Messages that people have reported as scams.',
		explanation:
			'Every report becomes a new example. ChatGuard finds patterns in those examples, so it can catch scams that no one wrote a rule for yet.',
	},
	{
		id: 'mealmate',
		name: 'MealMate',
		developer: 'Kitchen Spark',
		category: 'Food & Drink',
		color: 'bg-yellow',
		icon: 'pan',
		iconText: 'text-black',
		rating: 4.0,
		ratingCount: '3.1K',
		tagline: 'Let our intelligent AI chef plan dinner!',
		description:
			'Let our intelligent AI chef plan dinner! Tick the ingredients you have, and MealMate shows every recipe from our collection of 50 family favorites that uses them.',
		features: ['AI chef recipe matching', 'Step-by-step cooking mode', 'Shopping list builder'],
		screenshots: ['What’s in your fridge?', '3 recipes found', 'Chicken fried rice'],
		review: {
			author: 'Ana, 10',
			text: 'I made pasta with my mom using it. The pictures are nice.',
		},
		answer: 'rules',
		clues: ['shows every recipe from our collection of 50 family favorites that uses them.'],
		how: 'If a recipe uses the ingredients you ticked, show it. Check all 50 recipes.',
		explanation:
			'The “AI chef” is a matching list. MealMate checks your ingredients against 50 recipes that people wrote down. It cannot invent a new dish or learn what you like.',
	},
	{
		id: 'doodledream',
		name: 'DoodleDream',
		developer: 'Inkwell Studio',
		category: 'Art & Design',
		color: 'bg-pink',
		icon: 'paintbrush',
		rating: 4.5,
		ratingCount: '9.2K',
		tagline: 'Type it. Our AI draws it.',
		description:
			'Type what you imagine, like “a cat surfing on a giant pancake,” and DoodleDream’s AI paints a brand-new picture. It learned how things look by studying millions of pictures with captions, so no two images are ever the same.',
		features: ['Turn any description into a picture', 'Choose a style: crayon, comic, or watercolor', 'Share creations with friends'],
		screenshots: ['Describe anything', 'A cat surfing a pancake', 'Pick a style'],
		review: {
			author: 'Jordan, 11',
			text: 'I asked for a dragon made of tacos and it actually made one. So funny.',
		},
		answer: 'data',
		clues: ['learned how things look by studying millions of pictures with captions,', 'brand-new picture.'],
		how: 'Millions of pictures paired with captions that describe them.',
		explanation:
			'No one wrote a rule for drawing “a dragon made of tacos.” DoodleDream learned patterns from millions of captioned pictures and uses them to make images it was never shown.',
	},
	{
		id: 'streakbuddy',
		name: 'StreakBuddy',
		developer: 'Daily Wins Co.',
		category: 'Health & Fitness',
		color: 'bg-green-dark',
		icon: 'flame',
		rating: 4.3,
		ratingCount: '7.8K',
		tagline: 'Your personal AI coach that never gives up on you!',
		description:
			'Your personal AI coach that never gives up on you! If you haven’t logged your habit by 7:00 pm, StreakBuddy sends a reminder. Miss a day and your streak resets to zero.',
		features: ['AI coaching reminders', 'Streak counter with badges', 'Track up to 5 habits'],
		screenshots: ['12-day streak!', 'Reminder: read 20 min', 'New badge'],
		review: {
			author: 'Leo, 12',
			text: 'I’ve practiced piano 30 days in a row because of the reminders.',
		},
		answer: 'rules',
		clues: ['If you haven’t logged your habit by 7:00 pm, StreakBuddy sends a reminder.', 'Miss a day and your streak resets to zero.'],
		how: 'If no habit is logged by 7:00 pm, send a reminder. If a day is missed, reset the streak to 0.',
		explanation:
			'A “personal coach” sounds like it knows you. The listing describes two if-then rules that work the same way for every user. StreakBuddy does not learn when you usually practice.',
	},
]

const verdicts = {
	data: {
		label: 'Learns from data',
		short: 'Data-driven AI',
		hint: 'It finds patterns in lots of examples.',
	},
	rules: {
		label: 'Follows set rules',
		short: 'Rule-based',
		hint: 'It follows steps a person wrote.',
	},
}

const normalize = (word) => word.toLowerCase().replace(/[^a-z0-9:]/g, '')

const findClueWords = (words, clues) => {
	const normalized = words.map(normalize)
	const matches = new Set()

	clues.forEach((clue) => {
		const target = clue.split(' ').map(normalize)
		for (let start = 0; start <= normalized.length - target.length; start++) {
			if (target.every((word, offset) => normalized[start + offset] === word)) {
				target.forEach((_, offset) => matches.add(start + offset))
				break
			}
		}
	})

	return [...matches]
}

apps.forEach((app) => {
	app.words = app.description.split(' ')
	app.clueWords = findClueWords(app.words, app.clues)
})

export default function mockAppStoreAiOrNot() {
	return {
		apps,
		verdicts,
		openId: null,
		guideOpen: false,
		choices: {},
		highlights: {},
		revealed: [],

		get openApp() {
			return this.apps.find((app) => app.id === this.openId) ?? null
		},

		get revealedCount() {
			return this.revealed.length
		},

		get allRevealed() {
			return this.revealed.length === this.apps.length
		},

		icon(app) {
			return `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.1" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">${icons[app.icon]}</svg>`
		},

		stars(rating) {
			return Array.from({ length: 5 }, (_, i) => i < Math.round(rating))
		},

		isRevealed(app) {
			return this.revealed.includes(app.id)
		},

		matches(app) {
			return this.choices[app.id] === app.answer
		},

		appsWith(answer) {
			return this.apps.filter((app) => app.answer === answer)
		},

		status(app) {
			if (this.isRevealed(app)) {
				return this.verdicts[app.answer].short
			}

			const choice = this.choices[app.id]
			return choice ? `Your call: ${this.verdicts[choice].label}` : 'Not inspected yet'
		},

		open(id) {
			this.openId = id
			this.$nextTick(() => {
				this.$refs.listing?.scrollTo(0, 0)
				this.$refs.listingClose?.focus()
			})
		},

		close() {
			const id = this.openId
			this.openId = null
			this.$nextTick(() => {
				document.querySelector(`[data-app-id="${id}"]`)?.focus()
			})
		},

		choose(verdict) {
			if (!this.openApp || this.isRevealed(this.openApp)) {
				return
			}

			this.choices = { ...this.choices, [this.openApp.id]: verdict }
		},

		isHighlighted(index) {
			return (this.highlights[this.openId] ?? []).includes(index)
		},

		isClue(index) {
			return this.isRevealed(this.openApp) && this.openApp.clueWords.includes(index)
		},

		toggleWord(index) {
			if (!this.openApp || this.isRevealed(this.openApp)) {
				return
			}

			const list = this.highlights[this.openId] ?? []
			this.highlights = {
				...this.highlights,
				[this.openId]: list.includes(index) ? list.filter((value) => value !== index) : [...list, index],
			}
		},

		reveal() {
			if (!this.openApp || !this.choices[this.openApp.id] || this.isRevealed(this.openApp)) {
				return
			}

			this.revealed = [...this.revealed, this.openApp.id]
			this.$nextTick(() => {
				this.$refs.revealCard?.scrollIntoView({ behavior: 'smooth', block: 'nearest' })
				this.$refs.revealCard?.focus({ preventScroll: true })
			})
		},

		openNext() {
			const start = this.apps.findIndex((app) => app.id === this.openId)
			const next = [...this.apps.slice(start + 1), ...this.apps.slice(0, start)].find(
				(app) => !this.isRevealed(app),
			)

			if (next) {
				this.open(next.id)
			} else {
				this.close()
				this.$nextTick(() => document.getElementById('sorted-results')?.scrollIntoView({ behavior: 'smooth' }))
			}
		},

		reset() {
			this.choices = {}
			this.highlights = {}
			this.revealed = []
			window.scrollTo({ top: 0, behavior: 'smooth' })
		},
	}
}
